<template>
    <div class="voice-box">
        <div
            v-for="(item,index) in newForm"
            :key="index"
            class="voice-txt"
        >
            <p class="name">{{item.name}}</p>
            <el-slider
                class="slider"
                v-model="item.value"></el-slider>
        </div>
        <p class="btn-box">
            <el-button size="small" @click="handleTry">试听</el-button>
        </p>
    </div>
</template>

<script>
    export default {
        name: "VoiceChange",
        props: {
            form: Array
        },
        watch: {
            form(vl){this.newForm = vl},
            newForm(vl){this.$emit('update:form',vl)},
        },
        data(){
            return {
                newForm: this.form
            }
        },
        methods: {
            handleTry(){
                this.$emit('onVoiceTry')
            }
        }
    }
</script>

<style lang="scss" scoped>
.voice-box{
    display: flex;
    flex-direction: row;
    margin-left: 10px;
    margin-top: 10px;

    .voice-txt{
        display: flex;
        flex-direction: row;
        align-items: center;

        .slider{
            width: 220px;
            margin: 0px 30px 0px 10px;
        }
    }
}
</style>
